/**
 * alertReducer.js
 * Talkroute
 *
 * Created by Vel Genov on 12/8/18
 * Copyright (c) 2018 Talkroute. All right reserved.
 */

import alertConstants from "../constants/alertConstants";

export interface IAlertReducer {
  type: string;
  message: string;
}

const initialState: IAlertReducer = {
  type: '',
  message: ''
}

/**
 * Called to process alert actions
 *
 * @param {*} state
 * @param {*} action
 */
function alert(state: IAlertReducer = initialState, action): IAlertReducer {
  switch (action.type) {
    case alertConstants.SUCCESS:
      return {
        type: "alert-success",
        message: action.message,
      };
    case alertConstants.ERROR:
      return {
        type: "alert-danger",
        message: action.message,
      };
    case alertConstants.CLEAR:
      return initialState;
    default:
      return state;
  }
}

export default alert;
